export default __webpack_public_path__ + "static/media/ic_status_prepare.ff20f457.svg";